import { gql } from '@apollo/client'

export const GET_PAGED_APP_SETTINGS_QUERY = gql`
  query GetPagedAppSettings(
    $after: String
    $before: String
    $first: Int
    $last: Int
    $order: [AppSettingSortInput!]
    $where: AppSettingFilterInput
  ) {
    appSettings(after: $after, before: $before, first: $first, last: $last, order: $order, where: $where) {
      edges {
      node {
        id
        key
        displayName
        value
        lastModifiedBy
        lastModifiedAt
      }
    }
    totalCount
    pageInfo {
      startCursor
      endCursor
      hasPreviousPage
      hasNextPage
    }
  }
}
`

export const GET_APP_SETTING_BY_KEY_QUERY = gql`
  query GetAppSettingByKey($key: String!) {
    appSettingByKey(key: $key) {
      key,
      displayName,
      description,
      value,
      valueType,
      lastModifiedBy,
      lastModifiedAt
    }
  }
`

export const GET_APP_SETTING_BY_ID_QUERY = gql`
  query GetAppSettingById($id: Long!) {
    appSetting(appSettingId: $id) {
      id,
      key,
      displayName,
      description,
      value,
      valueType,
      lastModifiedBy,
      lastModifiedAt
    }
  }
`